export const cellStyling = 'py-2 px-3 text-sm text-center ';
